import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  Button,
  Card,
  Typography,
  Input,
  Rate,
  Badge,
  Carousel,
   Divider,
} from 'antd';
import {
  SearchOutlined,
  ClockCircleOutlined,
  UserOutlined,
  ArrowRightOutlined,
  CheckCircleFilled,
  StarFilled,
  TeamOutlined,
  GlobalOutlined,
} from '@ant-design/icons';
import {
  MdSchool, MdWork, MdTrendingUp,
  MdComputer, MdLocalHospital, MdBusiness, MdLanguage, MdSettings, MdPerson, MdBuild,
  MdVerifiedUser,
} from 'react-icons/md';
import styled, { createGlobalStyle } from 'styled-components';
import courseService from '../../services/courses';
import PublicPageLayout from '../../components/PublicPageLayout';
import Spinner from '../../components/Spinner';

const { Title, Text, Paragraph } = Typography;

const GlobalHomeStyle = createGlobalStyle`
  body {
    background-color: #fff;
    color: #333;
    margin: 0;
    padding: 0;
  }
`;

const TestimonialWrapper = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const THUMBS = [
  'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&q=80',
  'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=400&q=80',
  'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=400&q=80',
  'https://images.unsplash.com/photo-1551434678-e076c223a692?w=400&q=80',
  'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=400&q=80',
  'https://images.unsplash.com/photo-1543966888-7c1dc482a810?w=400&q=80',
  'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&q=80',
  'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=400&q=80',
];


const HeroWrapper = styled.section`
  background: url('/wxw4.jpg');
  background-size: cover;
  background-position: center;
  padding: 80px 20px 60px;
  text-align: center;
  position: relative;
  overflow: hidden;
  color: #111827;

  @media (max-width: 768px) {
    padding: 60px 16px 40px;
  }

  @media (max-width: 480px) {
    padding: 40px 12px 30px;
  }
`;

const HeroPills = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #f3f4f6;
  border-radius: 50px;
  padding: 6px;
  gap: 4px;
  margin-bottom: 40px;
  flex-wrap: wrap;
`;

const Pill = styled(Link)`
  background: ${props => props.active ? 'hsl(33, 100%, 50%)' : 'transparent'};
  color: ${props => props.active ? 'white' : '#4b5563'} !important;
  border: none;
  padding: 12px 24px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  box-shadow: none;

  &:hover {
    background: ${props => props.active ? 'hsl(33, 100%, 45%)' : 'rgba(0,0,0,0.05)'};
  }

  @media (max-width: 640px) {
    padding: 10px 16px;
    font-size: 13px;
    flex: 1 1 auto;
    justify-content: center;
  }
`;

const BigHeroTitle = styled.h1`
  font-size: 2.8rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 32px;
  letter-spacing: -0.5px;
  line-height: 1.2;

  @media (max-width: 1024px) {
    font-size: 2.4rem;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 24px;
  }

  @media (max-width: 480px) {
    font-size: 1.6rem;
    margin-bottom: 20px;
  }
`;

const BigSearchContainer = styled.div`
  max-width: 750px;
  margin: 0 auto 60px;
  position: relative;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05); 
  border-radius: 50px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  background: #fff;
  padding: 8px;
  transition: all 0.3s ease;

  &:focus-within {
    border-color: hsl(33, 100%, 50%);
    box-shadow: 0 10px 25px rgba(255, 140, 0, 0.1);
  }

  @media (max-width: 768px) {
    margin: 0 16px 40px;
    padding: 4px;
  }

  @media (max-width: 480px) {
    margin: 0 8px 30px;
  }

  .search-icon {
    font-size: 24px;
    color: #1b436f;
    margin: 0 24px;

    @media (max-width: 768px) {
      font-size: 20px;
      margin: 0 16px;
    }

    @media (max-width: 480px) {
      font-size: 18px;
      margin: 0 12px;
    }
  }
  input {
    flex: 1;
    border: none;
    font-size: 1.2rem;
    padding: 18px 0;
    outline: none;
    color: #1b436f;
    background: transparent;
    &::placeholder {
      color: #7a8ba3;
    }

    @media (max-width: 768px) {
      font-size: 1rem;
      padding: 14px 0;
    }

    @media (max-width: 480px) {
      font-size: 0.9rem;
      padding: 12px 0;
    }
  }
`;

const PartnerLogos = styled.div`
  text-align: center;
  margin-bottom: 60px;
  overflow: hidden;
  position: relative;
  width: 100%;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;

  /* Modern Mask: Smoothly fades edges to transparency regardless of background */
  mask-image: linear-gradient(to right, transparent, black 15%, black 85%, transparent);
  -webkit-mask-image: linear-gradient(to right, transparent, black 15%, black 85%, transparent);

  @media (max-width: 768px) {
    width: 100%;
    mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
    -webkit-mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
  }

  p {
    color: #4b5563;
    margin-bottom: 24px;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.5px;
    opacity: 0.9;
  }

  .carousel-track {
    display: flex;
    /* 11 icons * 2 clones for seamless loop = 22 total items */
    width: calc(150px * 22);
    animation: scroll 35s linear infinite;
  }

  .carousel-track:hover {
    animation-play-state: paused;
  }

  .slide {
    width: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  img {
    height: 45px;
    opacity: 0.8;
    transition: 0.3s;
  }

  img:hover {
    opacity: 1;
    transform: scale(1.1);
  }

  @keyframes scroll {
    0% { transform: translateX(0); }
    /* Slide over exactly one full set of 11 items */
    100% { transform: translateX(calc(-150px * 11)); }
  }
`;

const StatsBar = styled.div`
  background: #111827;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  padding: 20px 24px;
  flex-wrap: wrap;
  border-bottom: 4px solid hsl(33, 100%, 50%);
  @media (max-width: 768px) {
    gap: 32px;
    padding: 24px 16px;
  }

  @media (max-width: 480px) {
    gap: 16px;
    padding: 20px 12px;
    flex-direction: column;
    align-items: flex-start;
  }

  .stat-item {
    display: flex;
    align-items: center;
    gap: 12px;
    font-weight: 600;
    font-size: 14px;
  }

  .stars {
    color: hsl(33, 100%, 50%); /* Changed from Trustpilot green to theme orange */
    font-size: 18px;
  }
`;

// --- EXISTING SECTIONS (Course Grid, Footer, etc) ---
const SectionTitle = styled.div`
  text-align: center;
  margin-bottom: 48px;
  h2 {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 8px;
  }
  p {
    color: #666;
    font-size: 1.1rem;
  }
  @media (max-width: 768px) {
    padding: 0 20px;
    h2 { font-size: 1.6rem; }
    p { font-size: 1rem; }
  }
`;

const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 24px;
  max-width: 1280px;
  margin: 0 auto 80px;
  padding: 0 20px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 16px;
  }
`;

const CategoryCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px 20px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid transparent;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 30px rgba(0,0,0,0.15);
  }

  .watermark {
    position: absolute;
    bottom: -15px;
    right: -15px;
    font-size: 80px;
    color: rgba(0, 0, 0, 0.05);
    transform: rotate(-15deg);
    transition: all 0.3s ease;
    z-index: 0;
  }

  &:hover .watermark {
    transform: rotate(0deg) scale(1.1);
    color: rgba(255, 140, 0, 0.1);
  }

  .icon {
    font-size: 44px;
    color: hsl(210, 55%, 22%);
    margin-bottom: 20px;
    position: relative;
    z-index: 1;
  }

  span {
    display: block;
    font-weight: 700;
    font-size: 1.1rem;
    color: #111827;
    position: relative;
    z-index: 1;
  }
`;

const CourseSection = styled.section`
  background: #fff;
  padding: 80px 0;
  border-bottom: 1px solid #f0f0f0;
`;

const CourseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 32px;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
`;

const StyledCourseCard = styled(Card)`
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #eaeaea;
  transition: all 0.3s ease;
  background: #fff;

  &:hover {
    box-shadow: 0 15px 35px rgba(0,0,0,0.08);
    transform: translateY(-5px);
    border-color: hsl(33, 100%, 50%);
  }

  .ant-card-cover img {
    height: 180px;
    object-fit: cover;
    border-bottom: 1px solid #f0f0f0;
  }

  .ant-card-body {
    padding: 24px;
  }
`;

const CourseType = styled.span`
  background: #fff3e0;
  color: hsl(33, 100%, 45%);
  font-size: 0.75rem;
  font-weight: 700;
  padding: 6px 12px;
  border-radius: 20px;
  text-transform: uppercase;
  margin-bottom: 16px;
  display: inline-block;
  letter-spacing: 0.5px;
`;

const TestimonialSection = styled.section`
  background: hsl(210, 55%, 22%);
  color: white;
  padding: 100px 20px;
`;

const HireSection = styled.section`
  padding: 100px 40px;
  background: #ffffff;

  @media (max-width: 768px) {
    padding: 60px 16px;
  }
`;

const HireContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 20px 40px rgba(0,0,0,0.05);
  padding: 60px;
  borderRadius: 24px;
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 60px;
  align-items: center;

  @media (max-width: 1024px) {
    gap: 40px;
    padding: 40px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 32px 24px;
    gap: 32px;
  }
`;

const NewsletterSection = styled.section`
  padding: 80px 20px;
  text-align: center;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;

  @media (max-width: 768px) {
    padding: 50px 16px;
  }
`;

const NewsletterInputGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;

  @media (max-width: 640px) {
    flex-direction: column;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;

    .ant-input {
      width: 100% !important;
    }
    
    .ant-btn {
      width: 100% !important;
    }
  }
`;

const FeaturedHeader = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;


const Home = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const [searchQuery, setSearchQuery] = useState('');

  const handleGlobalSearch = (e) => {
    e.preventDefault();
    history.push({
      pathname: '/explore-courses',
      state: { query: searchQuery }
    });
  };

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const data = await courseService.getAllCourses();
        setCourses(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Failed to fetch courses:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCourses();
  }, []);

  const categories = [
    { id: 'IT', name: 'IT', icon: <MdComputer /> },
    { id: 'Health', name: 'Health', icon: <MdLocalHospital /> },
    { id: 'Business', name: 'Business', icon: <MdBusiness /> },
    { id: 'Management', name: 'Management', icon: <MdSettings /> },
    { id: 'Personal', name: 'Personal Dev', icon: <MdPerson /> },
    { id: 'Marketing', name: 'Marketing', icon: <MdTrendingUp /> },
    { id: 'Engineering', name: 'Engineering', icon: <MdBuild /> },
    { id: 'Teaching', name: 'Teaching', icon: <MdSchool /> },
    { id: 'Language', name: 'Language', icon: <MdLanguage /> },
  ];

  const featuredCourses = courses.slice(0, 8);

  return (
    <PublicPageLayout>
      <GlobalHomeStyle />

      {/* 1. Hero Section */}
      <HeroWrapper>
        <HeroPills>
          <Pill to="/explore-courses" active><MdSchool style={{ fontSize: 18 }} /> Learn & Get Certificates</Pill>
          <Pill to="/careers"><MdWork style={{ fontSize: 18, color: '#4b5563' }} /> Build Your Career</Pill>
          <Pill to="/careers"><MdTrendingUp style={{ fontSize: 18, color: '#4b5563' }} /> Earn On Wise Academy</Pill>
        </HeroPills>

        <BigHeroTitle>Free Online Courses & Valued Diplomas</BigHeroTitle>

        <BigSearchContainer as="form" onSubmit={handleGlobalSearch}>
          <button type="submit" style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}>
            <SearchOutlined className="search-icon" />
          </button>
          <input
            type="text"
            placeholder="What topic are you eager to explore today?"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </BigSearchContainer>

        <PartnerLogos>
          <p>Master the Most In Demand Technologies</p>
          <div className="carousel-track">
            {/* Original 11 Items */}
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg" title="React" alt="React" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/9/99/Unofficial_JavaScript_logo_2.svg" title="JavaScript" alt="JavaScript" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg" title="Python" alt="Python" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg" title="Node.js" alt="Node.js" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/en/3/30/Java_programming_language_logo.svg" title="Java" alt="Java" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/6/61/HTML5_logo_and_wordmark.svg" title="HTML5" alt="HTML5" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg" title="AWS" alt="AWS" /></div>
            <div className="slide"><img src="https://cdn-icons-png.flaticon.com/512/919/919853.png" title="Docker" alt="Docker" /></div>
            <div className="slide"><img src="https://miro.medium.com/v2/0*-BsXjt8Fm823qTSb.gif" title="Angular" alt="Angular" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/9/95/Vue.js_Logo_2.svg" title="Vue.js" alt="Vue.js" /></div>
            <div className="slide"><img src="https://staging.svgrepo.com/show/331488/mongodb.svg" title="MongoDB" alt="MongoDB" /></div>

            {/* Cloned 11 Items for Seamless Looping */}
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg" title="React" alt="React" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/9/99/Unofficial_JavaScript_logo_2.svg" title="JavaScript" alt="JavaScript" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg" title="Python" alt="Python" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg" title="Node.js" alt="Node.js" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/en/3/30/Java_programming_language_logo.svg" title="Java" alt="Java" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/6/61/HTML5_logo_and_wordmark.svg" title="HTML5" alt="HTML5" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg" title="AWS" alt="AWS" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/4/4e/Docker_%28container_engine%29_logo.svg" title="Docker" alt="Docker" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/c/cf/Angular_full_color_logo.svg" title="Angular" alt="Angular" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/commons/9/95/Vue.js_Logo_2.svg" title="Vue.js" alt="Vue.js" /></div>
            <div className="slide"><img src="https://upload.wikimedia.org/wikipedia/en/4/45/MongoDB-Logo.svg" title="MongoDB" alt="MongoDB" /></div>
          </div>
        </PartnerLogos>
      </HeroWrapper>

      {/* 2. Stats Bar */}
      <StatsBar>
        <div className="stat-item">
          Rated Excellent
          <span className="stars">
            <StarFilled /><StarFilled /><StarFilled /><StarFilled /><StarFilled />
          </span>
          Trustpilot
        </div>
        <div className="stat-item"><TeamOutlined /> 50+ Million Learners</div>
        <div className="stat-item"><MdVerifiedUser style={{ fontSize: 20 }} /> 15+ Million Graduates</div>
        <div className="stat-item"><GlobalOutlined /> 193 Countries</div>
      </StatsBar>

      <div style={{ padding: '40px 0', borderBottom: '1px solid #e0e0e0', background: '#fafafa' }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 24, flexWrap: 'wrap' }}>
          <Text strong style={{ fontSize: '1.2rem', color: '#333' }}>Begin Your Journey With 4,000+ Premium Courses</Text>
          <Button type="primary" shape="round" style={{ background: 'hsl(33, 100%, 50%)', borderColor: 'hsl(33, 100%, 50%)' }}>Browse Catalogue</Button>
        </div>
      </div>

      {/* Categories Grid */}
      <div style={{ padding: '100px 0 80px', background: 'hsl(33, 100%, 50%)' }}>
        <SectionTitle>
          <h2 style={{ color: 'white' }}>Discover Top Learning Categories</h2>
          <p style={{ color: 'rgba(255,255,255,0.9)' }}>Select from a wide range of expert-led topics and fields.</p>
        </SectionTitle>
        <CategoryGrid>
          {categories.map((cat, i) => (
            <CategoryCard
              key={i}
              onClick={() => history.push({
                pathname: '/explore-courses',
                state: { catId: cat.id }
              })}
            >
              <div className="watermark">{cat.icon}</div>
              <div className="icon">{cat.icon}</div>
              <span>{cat.name}</span>
            </CategoryCard>
          ))}
        </CategoryGrid>
      </div>

      {/* Featured Courses */}
      <CourseSection style={{ background: '#f9fafb' }}>
        <FeaturedHeader>
          <Title level={2} style={{ margin: 0 }}>Featured Online Courses</Title>
          <Link to="/explore-courses" style={{ color: 'hsl(210, 55%, 22%)', fontWeight: 600 }}>Explore All Courses <ArrowRightOutlined /></Link>
        </FeaturedHeader>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 100 }}><Spinner size="large" /></div>
        ) : (
          <CourseGrid>
            {featuredCourses.length > 0 ? featuredCourses.map((course, i) => (
              <StyledCourseCard
                key={i}
                hoverable
                cover={<img alt={course.name} src={course.image || THUMBS[i % THUMBS.length]} />}
                onClick={() => history.push(`/course/${course._id || course.id}`)}
              >
                <CourseType>{course.type || 'Certificate'}</CourseType>
                <Title level={4} style={{ marginBottom: 16, height: 52, overflow: 'hidden' }}>{course.name}</Title>
                <div style={{ display: 'flex', gap: 16, color: '#666', fontSize: '0.9rem' }}>
                  <span><ClockCircleOutlined /> {course.duration || '15-20'} hrs</span>
                  <span><UserOutlined /> {Math.floor(Math.random() * 5000)}+</span>
                </div>
                <Divider style={{ margin: '16px 0' }} />
                <Button block type="primary" style={{ background: 'hsl(33, 100%, 50%)', borderColor: 'hsl(33, 100%, 50%)' }}>Preview Course</Button>
              </StyledCourseCard>
            )) : <Text>No courses found in database.</Text>}
          </CourseGrid>
        )}
      </CourseSection>

      {/* Hire Section */}
      <HireSection>
        <HireContainer>
          <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
            <img src="/rwanda_classroom_teaching_1773156440669.png" alt="Rwandan Classroom" style={{ borderRadius: 16, width: '100%', maxWidth: 550, boxShadow: '0 10px 20px rgba(0,0,0,0.1)' }} />
          </div>
          <div>
            <Badge status="processing" color="hsl(33, 100%, 50%)" text={<span style={{ fontWeight: 700, letterSpacing: 1, color: 'hsl(33, 100%, 50%)' }}>ACCELERATE YOUR GROWTH</span>} style={{ marginBottom: 16 }} />
            <Title level={1} className="responsive-title" style={{ letterSpacing: '-0.5px', color: 'hsl(210, 55%, 22%)', marginBottom: 24 }}>Acquire High-Demand Capabilities.</Title>
            <Paragraph style={{ fontSize: '1.1rem', color: '#555', marginBottom: 40, lineHeight: 1.6 }}>
              Unlock your potential by joining our global community of ambitious learners. Secure verified certifications from esteemed educators, meticulously tailored to thrive in the modern African job market.
            </Paragraph>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 24 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <CheckCircleFilled style={{ color: 'hsl(33, 100%, 50%)', fontSize: 24 }} />
                <Text strong style={{ fontSize: '1.05rem', color: '#333' }}>Verified Certifications</Text>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <CheckCircleFilled style={{ color: 'hsl(33, 100%, 50%)', fontSize: 24 }} />
                <Text strong style={{ fontSize: '1.05rem', color: '#333' }}>Industry Specialists</Text>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <CheckCircleFilled style={{ color: 'hsl(33, 100%, 50%)', fontSize: 24 }} />
                <Text strong style={{ fontSize: '1.05rem', color: '#333' }}>Permanent Access</Text>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <CheckCircleFilled style={{ color: 'hsl(33, 100%, 50%)', fontSize: 24 }} />
                <Text strong style={{ fontSize: '1.05rem', color: '#333' }}>Dedicated Support</Text>
              </div>
            </div>
            <Button type="primary" size="large" className="responsive-btn" style={{ marginTop: 40, background: 'hsl(210, 55%, 22%)', borderColor: 'hsl(210, 55%, 22%)', borderRadius: 8, height: 50, padding: '0 32px' }}>Explore Career Paths</Button>
          </div>
        </HireContainer>
      </HireSection>

      {/* Success Stories */}
      <TestimonialSection>
        <TestimonialWrapper>
          <div>
            <Title level={1} style={{ marginBottom: 24, letterSpacing: '-0.5px', color: 'white' }}>Join Millions Transforming Their Lives With Wise Academy</Title>
            <Paragraph style={{ fontSize: '1.15rem', color: '#e0e0e0', lineHeight: 1.6, marginBottom: 32 }}>
              Discover how our alumni from Kigali and throughout the continent are utilizing their online education to achieve breakthrough success within their respective industries.
            </Paragraph>
            <Button type="primary" size="large" style={{ background: 'hsl(33, 100%, 50%)', color: 'white', borderColor: 'hsl(33, 100%, 50%)', borderRadius: 8, fontWeight: 600 }}>Browse Alumni Stories</Button>
          </div>
          <div style={{ position: 'relative' }}>
            <Carousel autoplay effect="fade">
              <Card style={{ borderRadius: 16, border: 'none', padding: 32, boxShadow: '0 20px 40px rgba(0,0,0,0.2)' }}>
                <div style={{ textAlign: 'center' }}>
                  <img src="/african_graduates_celebrating_1773156461222.png" alt="Graduates" style={{ width: '100%', height: 260, objectFit: 'cover', borderRadius: 12, marginBottom: 24 }} />
                  <Rate disabled defaultValue={5} style={{ marginBottom: 24, color: 'hsl(33, 100%, 50%)' }} />
                  <Paragraph style={{ fontSize: '1.2rem', fontWeight: 500, color: '#333', fontStyle: 'italic', marginBottom: 24 }}>
                    "The knowledge I gained from WISE Academy was instrumental. The curriculum's flexibility allowed me to study while working, and the certification definitively led to my promotion as a Lead Developer."
                  </Paragraph>
                  <Title level={4} style={{ color: 'hsl(210, 55%, 22%)', margin: 0 }}>Marie Uwase</Title>
                  <Text style={{ color: '#888', fontWeight: 500 }}>Lead Software Engineer</Text>
                </div>
              </Card>
            </Carousel>
          </div>
        </TestimonialWrapper>
      </TestimonialSection>

      {/* Newsletter */}
      <NewsletterSection>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <Title level={1} style={{ color: 'hsl(210, 55%, 22%)', letterSpacing: '-0.5px' }}>Begin Your Learning Journey Today at No Cost!</Title>
          <Paragraph style={{ color: '#555', fontSize: '1.15rem', marginBottom: 32, lineHeight: 1.6 }}>
            Become part of our thriving ecosystem of lifelong learners. Register now to receive the latest updates, curated course recommendations, and career insights.
          </Paragraph>
          <NewsletterInputGroup>
            <Input placeholder="Enter your best email address" style={{ width: 340, borderRadius: 8, height: 50, fontSize: '1rem', border: '1px solid #ccc' }} />
            <Button type="primary" size="large" style={{ background: 'hsl(33, 100%, 50%)', borderColor: 'hsl(33, 100%, 50%)', borderRadius: 8, height: 50, fontWeight: 600, padding: '0 32px', boxShadow: 'none' }}>Enroll Instantly</Button>
          </NewsletterInputGroup>
        </div>
      </NewsletterSection>
    </PublicPageLayout>
  );
};

export default Home;